import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { CheckOutlined, EditOutlined } from "@ant-design/icons";
import { Switch, Progress } from "antd";

import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import DeleteButton from "components/buttons/DeleteButton";
import Loading from "components/App/Loading";
import ManageOrder from "components/Modals/ManageOrder";
import Table from "components/Tables/Table";
// import Filters from "components/dashboard/Filters";
import { getUserState } from "state/selector";
import { states } from "constants/app";
import { GlassCard } from "components/App/styled";
import Todo from "./Todo";

const Filters = ({ setStatus, reload }) => (
  <div style={{ marginTop: 32 }}>
    نمایش همه :
    <Switch
      style={{ marginRight: 8 }}
      onChange={(state) => {
        reload(true);
        setStatus(state ? "" : "/active");
      }}
    />
  </div>
);

function Index({ user }) {
  const [manageProductModal, setManageProductModal] = useState(false);
  const [todoModal, setTodoModal] = useState(false);
  const [data, setData] = useState(false);
  const [reload, setReload] = useState(false);
  const [orders, setOrders] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [status, setStatus] = useState("/active");

  useEffect(() => {
    Fetch.get(`/orders${status}`, (res) => {
      console.log("orders/" + status, res);
      if (res) {
        setOrders(res.orders.filter((item) => item.visitor === user.name));
        setData(res);
        setReload(false);
      }
    });
  }, [reload, status]);

  function handleUpdate(index) {
    setUpdateModal(orders[index]);
  }
  console.log("render");

  if (!data || !user) {
    return <Loading />;
  }
  return (
    <Container>
      <HeaderContainer>
        <HeaderCard>
          <Progress type="circle" percent={30} width={75} />
          وضعیت تارگت
        </HeaderCard>
        <Todo
          reload={setReload}
          visible={todoModal}
          setVisible={setTodoModal}
          userData={user}
        />
      </HeaderContainer>
      <GlassCard style={{ padding: "12px 4px", marginBottom: 20 }}>
        <ManageOrder
          reload={setReload}
          data={data}
          visible={manageProductModal}
          setVisible={setManageProductModal}
        />
        {updateModal && (
          <ManageOrder
            reload={setReload}
            data={data}
            oldData={updateModal}
            visible={updateModal ? true : false}
            setVisible={setUpdateModal}
            buttonStyle={{ display: "none" }}
          />
        )}

        <Title>سفارش های اخیر</Title>
        <Filters
          data={data}
          orders={orders}
          setOrders={setOrders}
          setStatus={setStatus}
          reload={setReload}
        />
      </GlassCard>
      <TableContainer>
        <Table
          loading={reload}
          columns={tableHeaders}
          dataSource={
            orders?.length &&
            orders?.map((item, index) => ({
              ...item,
              state: states[item.state].icon,
              actions: item.state ? (
                <div className="center">
                  تحویل داده شده
                  <CheckOutlined
                    style={{ color: colors.green, fontSize: 18 }}
                  />
                </div>
              ) : (
                <div className="center row">
                  <Button
                    style={{ marginRight: 6 }}
                    onClick={() => handleUpdate(index)}
                  >
                    <EditOutlined />
                  </Button>
                  <DeleteButton
                    id={item.id}
                    reload={setReload}
                    title="سفارش"
                    link="orders"
                  />
                </div>
              ),
              key: index + 1,
            }))
          }
        />
      </TableContainer>
    </Container>
  );
}
const mapStateToProps = (state) => {
  const user = getUserState(state);
  return { user };
};
export default connect(mapStateToProps)(Index);
const Container = styled.div`
  color: ${colors.dark};
`;
const TableContainer = styled.div``;
const Title = styled.h2`
  margin-top: 24px;
  margin-bottom: 0;
`;
const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-content: center;
  align-items: center;

  margin-bottom: 16px;
`;
export const HeaderCard = styled.div`
  background: ${colors.white + "8a"};
  box-shadow: 0 3px 8px 1px #11132e25;
  backdrop-filter: blur(6px);
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: block;

  font-size: 0.8rem;
  width: 36vw;
  height: 40vw;
  max-width: 150px;
  max-height: 150px;

  padding: 12px 10px;
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
`;
const tableHeaders = [
  {
    title: "شمار",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "80px",
  },
  {
    title: "نام مشتری",
    dataIndex: "customer",
    key: "customer",
    align: "center",
  },
  { title: "نام فروشگاه", dataIndex: "shop", key: "shop", align: "center" },
  { title: "آدرس", dataIndex: "address", key: "address", align: "center" },
  { title: "تلفن", dataIndex: "phone", key: "phone", align: "center" },
  { title: "ویزیتور", dataIndex: "visitor", key: "visitor", align: "center" },
  { title: "مرحله", dataIndex: "state", key: "state", align: "center" },
  { title: "اعمال", dataIndex: "actions", key: "actions", align: "center" },
];
